module.exports = __webpack_public_path__ + "images/backgrounds/canyon/large.1596d9221adb1e3411ed.jpg";